import * as React from 'react';

function SvgIconIntroTime(props) {
  return (
    <svg viewBox="0 0 40 39" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M6.55 19.5c0 4.68 2.56 9.01 6.72 11.35a13.72 13.72 0 0013.43 0 13.06 13.06 0 006.72-11.35c0-4.68-2.56-9.01-6.72-11.35a13.72 13.72 0 00-13.43 0A13.06 13.06 0 006.55 19.5z"
          fill="#FCCE01"
        />
        <path
          d="M19.98 39a20.1 20.1 0 01-16.75-8.87 19.1 19.1 0 01-1.51-18.54A1.18 1.18 0 013.27 11c.29.12.51.35.62.64.12.28.1.6-.02.87-1 2.2-1.52 4.58-1.52 6.99 0 7.36 4.8 13.9 11.93 16.28a17.9 17.9 0 0019.64-5.74 16.87 16.87 0 00.8-20 17.84 17.84 0 00-19.13-7.2c-.4.1-.84-.02-1.14-.31-.29-.3-.4-.72-.29-1.12.11-.4.43-.7.84-.8A20.4 20.4 0 0119.98 0c11.04 0 19.98 8.73 19.98 19.5S31.02 39 19.98 39z"
          fill="#4C4C4C"
        />
        <path
          d="M19.98 9.33c-.3 0-.6-.13-.83-.34-.22-.22-.34-.5-.34-.81v-1.8c0-.62.53-1.14 1.17-1.14.65 0 1.18.52 1.18 1.15v1.79c0 .63-.53 1.15-1.18 1.15zM8.38 20.65H6.55c-.65 0-1.17-.52-1.17-1.15 0-.63.52-1.15 1.17-1.15h1.83c.65 0 1.18.52 1.18 1.15 0 .63-.53 1.15-1.18 1.15zm11.6 13.1c-.3 0-.6-.11-.83-.33a1.1 1.1 0 01-.34-.8v-1.8c0-.63.53-1.15 1.17-1.15.65 0 1.18.52 1.18 1.15v1.8c0 .62-.53 1.14-1.18 1.14zm13.44-13.1h-1.84c-.64 0-1.17-.52-1.17-1.15 0-.63.53-1.15 1.17-1.15h1.84c.65 0 1.17.52 1.17 1.15 0 .63-.52 1.15-1.17 1.15zm-4.68 4.85c-.2 0-.4-.06-.59-.15l-8.74-4.85a1.15 1.15 0 01-.55-.68l-1.84-6.2c-.14-.59.22-1.19.82-1.35.6-.17 1.24.15 1.44.73l1.7 5.73 8.34 4.59c.56.31.76 1 .44 1.56-.2.37-.59.61-1.02.62zM8.11 6.4c-.5 0-.94-.3-1.1-.76-.18-.46-.03-.97.36-1.28.37-.29.73-.55 1.1-.81a1.2 1.2 0 011.58.32c.35.49.26 1.16-.22 1.55-.33.23-.66.47-.98.72-.2.17-.47.26-.74.26z"
          fill="#4C4C4C"
        />
      </g>
    </svg>
  );
}

export default SvgIconIntroTime;
